import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tagName"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { hidden } from '../utils/propTypes/decorators';
import { jsx as _jsx } from "react/jsx-runtime";
const Heading = styled(props => {
  const _ref = props,
    {
      tagName: Tag
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Tag, Object.assign({}, rest));
}).withConfig({
  displayName: "Heading",
  componentId: "sc-16nd9wf-0"
})([""]);
Heading.propTypes = {
  'aria-level': PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  tagName: hidden(PropTypes.elementType.isRequired)
};
Heading.defaultProps = {
  'aria-level': 2,
  tagName: 'span'
};
export default Heading;